import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import DesktopLayout from './Layout/DesktopLayout';
import { ScrollProvider } from './hook/ScrollContext';
import Policy from './page/Policy';

function App() {
  return (
    <ScrollProvider>
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={<DesktopLayout />} />
          <Route path={"/legal"} element={<Policy />} />
        </Routes>
      </BrowserRouter>
    </ScrollProvider>
  )
}

export default App;
